import { excluded } from 'vee-validate/dist/rules';
import { ValidatorUtils } from './utils';

export const excludedValidator = {
    ...excluded,
    message(field: string) {
        return `'${ValidatorUtils.prettifyName(field)}' already exists`;
    },
};
